import React from "react";
import Carousel from "../layout/Carousel";
import CarouselVideo from "../layout/CarouselVideo";
import WhereTravelling from "../layout/WhereTravelling";
import MeetMighty from "../layout/MeetMighty";
import MightyESim from "../layout/MightyESim";
import Homepromo from "../layout/Homepromo";
import CustomerReviews from "../layout/CustomerReviews";
import Coverages from "../layout/Coverages";
import ImageSlider from "../layout/ImageSlider";
import HowItVideo from "../layout/HowItVideo";
import HowItUse from "../layout/HowItUse";
import MightyWifiApp from "../layout/MightyWifiApp";
import StayTouch from "../layout/StayTouch";
import TitleBar from "../layout/TitleBar";
import Global from "../layout/Global";
import Reason from "../layout/Reason";
import layoutWrapper from "../components/Hoc/layoutWrapper";
import moment from "moment";
import {confirmAlert} from "react-confirm-alert";
import PromoModal from "../layout/PromoModal";
import AlertModal from "../layout/AlertModal";
import OutageModal from "../layout/OutageModal";

class LandingpageModal extends React.Component {
    constructor(props) {
        super(props);
        /*if(this.showNotice()) {
            this.notice();
        }*/
        //this.notice();
    }
    showNotice() {
        var now = moment();

        var year = 2021;
        var month = 9;
        var date = 2;
        var hour = 19;
        var min = 0;

        var dateToCheck = now.year(year).month( month - 1).date(date).hour(hour).minute(min);

        //console.log(now);
        //console.log(dateToCheck);

        return moment().isAfter(dateToCheck);
    }
    notice() {
        confirmAlert({
            title: 'Notice',
            //message: 'Due to the tropical storm Isaias, service may be temporarily interrupted. We apologize for the inconvenience.',
            message: 'We regret to inform you that our system is currently experiencing an unexpected outage. Our technical team is actively working to resolve the issue and restore normal operations as quickly as possible. During this time, the system is inaccessible, and all services are temporarily unavailable.',
            buttons: [
                {
                    label: 'Ok'
                }
            ]
        });
    }
    noticeCustom() {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        {/*<h1>Notice</h1>*/}
                        <h3>Our service has been suspended due to power outage caused by hurricane Ida.</h3>
                        <p>PSEG is working hard to restoring the power in the area.</p>
                        <ul style={{ listStyleType: "decimal"}}>
                            <li>Restoring your service is our top priority.</li>
                            <li>Your expiration date will be extended to make up the losses.</li>
                            <li>Please email us at <a href="mailto:support@mightywifi.net">support@mightywifi.net</a> with any questions or concerns.</li>
                        </ul>
                        <button onClick={onClose} >Ok</button>
                    </div>
                );
            }
        });
    }
    render() {
        return (
            <div>
                {/*<AlertModal/>*/}
                {/*<AlertModal showModal={this.props.showModal}/>*/}
                {/*<PromoModal />*/}
                {/*<OutageModal/>*/}
                <CarouselVideo />
                <MightyESim />
                <Homepromo />
                <Global />
                <Reason />
                {/*<WhereTravelling />*/}
                {/*<TitleBar />*/}
                {/*<MeetMighty />*/}
                <CustomerReviews />
                {/*<Coverages />*/}
                <HowItUse />
                <MightyWifiApp />
                <HowItVideo />
                <ImageSlider />
                <StayTouch />
            </div>
        );
    }
}

export default layoutWrapper(LandingpageModal);



// WEBPACK FOOTER //
// ./src/pages/Landingpage.js